import React from 'react';
import { cn } from '../../utils/cn';

export interface FieldProps {
  label: string;
  htmlFor: string;
  hint?: React.ReactNode;
  error?: string;
  optional?: boolean;
  children: React.ReactNode;
  className?: string;
}

/** Label + control + hint/error, wired for accessibility by the caller via aria-describedby. */
export const Field: React.FC<FieldProps> = ({ label, htmlFor, hint, error, optional, children, className }) => (
  <div className={cn('flex flex-col gap-1.5', className)}>
    <label htmlFor={htmlFor} className="text-sm font-medium text-ink">
      {label}
      {optional && <span className="font-normal text-muted"> (optional)</span>}
    </label>
    {children}
    {hint && (
      <p id={`${htmlFor}-hint`} className="text-sm text-muted">
        {hint}
      </p>
    )}
    {error && (
      <p role="alert" className="text-sm text-danger-text">
        {error}
      </p>
    )}
  </div>
);
